/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { Amplify } from 'aws-amplify';
import { getAuthConfig } from './utils/requestConfig';
import { AppRoutes } from './routes/appRoutes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const callbackUrl = window.location.origin;
const authConfig = getAuthConfig();
const amplifyConfig = {
  Auth: {
    identityPoolId: authConfig.identityPoolId,
    region: authConfig.region,
    userPoolId: authConfig.userPoolId,
    userPoolWebClientId: authConfig.userPoolClientId,
    mandatorySignIn: false,
    signUpVerificationMethod: 'code',
    oauth: {
      domain: authConfig.domain,
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: callbackUrl,
      redirectSignOut: callbackUrl,
      responseType: 'code',
    },
  },
};
Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Query client queries are set to never go stale so that we always
      // pull in any cached data.  We then manually reset the queries on
      // user actions (such as navigating to a new page)
      // This ensures that we can use the same query in subcomponents as
      // a decomposed state, without falling into the accessibility pitfalls
      // of dynamically changing the app based on new query content
      staleTime: Infinity,
      // Query client is also set to not retry failed queries by default
      // This can be overridden on a query-by-query basis if retries are desired
      // However, most failures result from invalid search params, so we do not
      // want to retry them after the first failed call
      retry: false,
    },
  },
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AppRoutes />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
